export enum UserProfileSection {
  PersonalDetails = "profile",
  Security = "security",
  InternetBankingPrefs = "banking-prefs",
}
